import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  addPathikEntry,
  calculatePayableAmount,
  calculateStayDuration,
  cancelCheckIn,
  deleteCheckIn,
  formatTimeToAMPM,
  getCurrentLocalDateTime,
  getGuest,
  guestDataToupdate,
} from "../utils/helperFunctions";
import GuestAndCheckInForm from "../components/GuestAndCheckInForm";
import ReactPaginate from "react-paginate";
import { Mycontext } from "../context/context";
import CheckoutModal from "../components/CheckoutModal";
import { motion } from "framer-motion";
import {
  MdAdd,
  MdEdit,
  MdFilterAlt,
  MdClear,
  MdPerson,
  MdEmail,
  MdPhone,
  MdCalendarToday,
  MdCancel,
  MdPrint,
  MdCheck,
  MdDelete,
  MdWarning,
} from "react-icons/md";
import { toast } from "react-toastify";
import { format } from "date-fns";
import PDFContent from "../components/PDFContent";
import DeleteConfirmationModal from "../components/DeleteConfirmationModal";

const GuestData = ({ role }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = parseInt(searchParams.get("page")) || 1;
  const [guests, setGuests] = useState([]);
  const [editvalue, setEditvalue] = useState({});
  const [isEdit, setisEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);
  const { checkExtension, formToShow, checkOutData, setCheckOutData } =
    useContext(Mycontext);
  const [isRefeshing, setIsRefreshing] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    phone: "",
    fromDate: "",
    toDate: "",
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [guestToCancel, setGuestToCancel] = useState(null);
  const [isdownloadPdf, setisdownloadPdf] = useState(false);
  const [checkedGuests, setCheckedGuests] = useState([]);
  const [isSubmitting, setisSubmitting] = useState(false);
  const [summaryData, setSummaryData] = useState({
    totalGuests: 0,
    totalPaidAmountAllGuests: 0,
  });
  const [pdfdata, setPdfdata] = useState({});
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [guestToDelete, setGuestToDelete] = useState(null);
  const { date } = getCurrentLocalDateTime();
  // console.log("guests",guests);
  // console.log("currentPage",currentPage);
  // console.log("checkedGuests",checkedGuests)
  // const [fetchguestData,setfetchguestData] = useState(false);
  // console.log("guests", guests);
  // console.log("pdfdata in pages",pdfdata)
  // console.log("checkOutData",checkOutData);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [filters]);

  useEffect(() => {
    fetchGuests(currentPage);
  }, [currentPage, debouncedFilters]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && showCancelConfirmation) {
        event.preventDefault();
        setShowCancelConfirmation(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showCancelConfirmation]);

  const fetchGuests = async (page = 1) => {
    setIsRefreshing(true);
    try {
      const params = {
        page,
        ...(debouncedFilters.name.trim() && { name: debouncedFilters.name }),
        ...(debouncedFilters.email.trim() && { email: debouncedFilters.email }),
        ...(debouncedFilters.phone.trim() && { phone: debouncedFilters.phone }),
        ...(debouncedFilters.fromDate && {
          fromDate: debouncedFilters.fromDate,
        }),
        ...(debouncedFilters.toDate && { toDate: debouncedFilters.toDate }),
      };

      const response = await getGuest(params);
      if (response.data.status) {
        setSummaryData({
          totalGuests: response.data.totalGuests,
          totalPaidAmountAllGuests: response.data.totalPaidAmountAllGuests,
        });

        // Process the data before setting it in state
        const processedGuests = response.data.data.map((guest) => {
          // Check if guest is pending checkout (no checkout date/time and not cancelled)
          const isPendingCheckout =
            !guest.checkOutDate &&
            !guest.checkOutTime &&
            guest.isCancelled === false;

          if (!guest.isCancelled) {
            const endDate = isPendingCheckout
              ? new Date()
              : new Date(
                guest.checkOutDate.split("T")[0] + " " + guest.checkOutTime
              );
            const checkInDate = new Date(guest.checkInDate);
            const [hours, minutes] = guest.checkInTime.split(":");
            checkInDate.setHours(parseInt(hours, 10));
            checkInDate.setMinutes(parseInt(minutes, 10));

            const stayDuration = calculateStayDuration(checkInDate, endDate);
            const { payableHours, payableAmount } = calculatePayableAmount(
              stayDuration,
              guest.roomNumber.gracePeriod || 0,
              guest.roomNumber.hourlyPricing || [],
              checkInDate,
              endDate,
              guest.nightCheckInConfirmed,
              guest.roomNumber.nightStayPrice
            );

            return {
              ...guest,
              // stayDuration,
              // payableHours,
              payableAmount,
            };
          }
          return guest;
        });
        setGuests(processedGuests);
        setTotalPages(response.data.pagination.totalPages);
      }
    } catch (error) {
      console.error("Error fetching guests:", error);
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    if (guests.length === 0 && currentPage > 1) {
      const previousPage = 1;
      setCurrentPage(previousPage);
      setSearchParams({ page: previousPage });
    }
  }, [guests, currentPage, setSearchParams]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setSearchParams({ page: 1 });
    setCurrentPage(1);
    setFilters((prev) => {
      const newFilters = {
        ...prev,
        [name]: value,
      };
      if (
        name === "fromDate" &&
        value &&
        newFilters.toDate &&
        new Date(value) > new Date(newFilters.toDate)
      ) {
        newFilters.toDate = value; // Set toDate equal to fromDate
      }

      if (
        name === "toDate" &&
        value &&
        newFilters.fromDate &&
        new Date(value) < new Date(newFilters.fromDate)
      ) {
        newFilters.fromDate = value; // Set fromDate equal to toDate
      }

      return newFilters;
    });
  };

  const resetFilters = () => {
    if (
      filters.name ||
      filters.email ||
      filters.phone ||
      filters.fromDate ||
      filters.toDate
    ) {
      setFilters({
        name: "",
        email: "",
        phone: "",
        fromDate: "",
        toDate: "",
      });
      setSearchParams({ page: 1 });
      setCurrentPage(1);
    }
  };

  const handlePageClick = ({ selected }) => {
    const newPage = selected + 1;
    setCurrentPage(newPage);
    setSearchParams({ page: newPage });
    // window.scrollTo(0, 0);
  };

  const handleEdit = async (guest) => {
    try {

      const response = await guestDataToupdate(guest._id);
      if (response.data.status) {
        setEditvalue(response.data.data);
        setisEdit(true);
        checkExtension("formA");
      }
    } catch (error) {
      console.error("Error fetching guest details:", error);
    }
  };

  const handlePrint = async (guest) => {
    let downloadInfo = true;
    const response = await guestDataToupdate(guest._id, downloadInfo);

    if (response.data.status) {
      setisdownloadPdf(true);
      const apiData = response.data.data;
      const transformedData = {
        roomNo: guest.roomNumber.roomNo,
        ...apiData,
        ...apiData.guestId,
        address: {
          ...apiData.guestId?.address,
        },
      };
      setPdfdata(transformedData);
    }
  };

  const handleFormShow = () => {
    setisEdit(false);
    checkExtension("formA");
  };

  const handleCheckoutClick = async (guest) => {
    checkExtension("formB");
    setCheckOutData({
      checkInId: guest._id,
      checkInDate: guest.checkInDate,
      checkInTime: guest.checkInTime,
      gracePeriod: guest.roomNumber.gracePeriod,
      nightStayPrice: guest.roomNumber.nightStayPrice,
      hourlyPricing: guest.roomNumber.hourlyPricing,
      advancePayAmount: guest.advancePayAmount,
      nightCheckInConfirmed: guest.nightCheckInConfirmed,
    });
  };

  const handleCancelCheckin = (guest) => {
    setGuestToCancel(guest);
    setShowCancelConfirmation(true);
  };

  const handleDeleteGuest = (guest) => {
    setGuestToDelete(guest);
    setShowDeleteConfirmation(true);
  };

  const isCheckoutDelayed = (scheduledDate, scheduledTime, actualCheckout) => {
    const scheduledDateTime = new Date(
      `${scheduledDate.split("T")[0]}T${scheduledTime}`
    );
    const actualDateTime = new Date(actualCheckout);
    return Math.abs(actualDateTime - scheduledDateTime) > 5 * 60 * 1000;
  };

  const handleConfirmCancel = async () => {
    if (guestToCancel) {
      try {
        const response = await cancelCheckIn(guestToCancel._id);
        if (response.status) {
          toast.error(response.msg);
          fetchGuests(currentPage);
          setShowCancelConfirmation(false);
          setGuestToCancel(null);
        }
      } catch (error) {
        toast.error(error.response.data.msg);
      }
    }
  };

  const handleConfirmDelete = async () => {
    if (guestToDelete) {
      try {
        const response = await deleteCheckIn(guestToDelete._id);
        if (response.status) {
          toast.error(response.msg);
          fetchGuests(currentPage);
          setShowDeleteConfirmation(false);
          setGuestToDelete(null);
        }
      } catch (error) {
        toast.error(error.response.data.msg);
      }
    }
  };

  const handleCancelConfirmationClose = () => {
    setShowCancelConfirmation(false);
    setGuestToCancel(null);
  };

  const handleDeleteConfirmationClose = () => {
    setShowDeleteConfirmation(false);
    setGuestToDelete(null);
  };

  const renderPaymentDetails = (guest) => {
    // const paidAmount = (guest.advancePayAmount || 0) + (guest.paidAmount || 0);
    // const returnAmount = guest.returnAmount || 0;
    // const netPaid = paidAmount - returnAmount;
    const remaining =
      (guest.payableAmount || 0) - (guest.advancePayAmount || 0);

    return (
      <>
        <div className="text-xs text-green-600">
          Advance Paid: ₹{guest.advancePayAmount || 0}
        </div>
        {remaining > 0 ? (
          <div className="text-xs font-medium text-red-600">
            Due: ₹{remaining}
          </div>
        ) : (
          <div className="text-xs font-medium text-blue-600">
            Return: ₹{Math.abs(remaining)}
          </div>
        )}
      </>
    );
  };

  const handleCheckboxChange = (guest) => {
    setCheckedGuests((prev) => {
      if (prev.includes(guest._id)) {
        return prev.filter((id) => id !== guest._id);
      } else {
        return [...prev, guest._id];
      }
    });
  };

  const handleSubmitCheckedGuests = async () => {
    setisSubmitting(true);
    try {
      const response = await addPathikEntry(checkedGuests);
      // console.log("addPathikEntry", response);

      if (response.data.status) {
        toast.success(response.data.msg);
        setCheckedGuests([]);
        fetchGuests(currentPage);
      }
    } catch (error) {
      console.log("addPathikEntry", error);
      toast.error(error.response?.msg || "An error occurred");
    } finally {
      setisSubmitting(false);
    }
  };

  const getGuestBgColor = (guest, index) => {
    if (guest.nightCheckInConfirmed) {
      return "bg-sky-200";
    }
    if (guest.expectedCheckoutHour >= 4 || guest.advancePayAmount >= 800) {
      return "bg-indigo-200";
    }
    return index % 2 === 0
      ? "bg-white hover:bg-indigo-100/30"
      : "bg-indigo-50/30 hover:bg-indigo-100/30";
  };

  const isAllChecked = () => {
    if (guests.length === 0) return false;

    // Get all eligible guests (those that can be checked)
    const eligibleGuests = guests.filter(
      (guest) =>
        guest.isCompleteCheckInDetails &&
        !guest.generatedId &&
        guest.checkOutDate &&
        guest.checkOutTime &&
        role !== "view only"
    );

    if (eligibleGuests.length === 0) return false;

    return eligibleGuests.every((guest) => checkedGuests.includes(guest._id));
  };

  const handleCheckAll = () => {
    // Get all eligible guests (those that can be checked)
    const eligibleGuests = guests.filter(
      (guest) =>
        guest.isCompleteCheckInDetails &&
        !guest.generatedId &&
        guest.checkOutDate &&
        guest.checkOutTime &&
        role !== "view only" &&
        !guest.noPathikEntry &&
        !guest.processStatus
    );

    if (isAllChecked()) {
      // Uncheck all - remove all eligible guest IDs
      setCheckedGuests((prev) =>
        prev.filter((id) => !eligibleGuests.some((guest) => guest._id === id))
      );
    } else {
      // Check all - add all eligible guest IDs that aren't already checked
      const eligibleIds = eligibleGuests.map((guest) => guest._id);
      setCheckedGuests((prev) => {
        const newChecked = [...prev];
        eligibleIds.forEach((id) => {
          if (!newChecked.includes(id)) {
            newChecked.push(id);
          }
        });
        return newChecked;
      });
    }
  };

  // const clearAllCheckedGuests = () => {
  //   setCheckedGuests([]);
  // };

  return (
    <div className="p-4 md:p-6 bg-gray-50 ">
      <div className="container mx-auto bg-gradient-to-r from-indigo-50 to-blue-50 rounded-xl shadow-sm overflow-hidden">
        <div className="p-6">
          {/* Color Indicator Section */}
          <div className="flex gap-3 justify-end ">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-rose-300"></div>
              <span className="text-xs">No Pthk</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-green-300"></div>
              <span className="text-xs">Complete Details</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-yellow-300"></div>
              <span className="text-xs">Incomplete Details</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-purple-300"></div>
              <span className="text-xs">Pathik Entry Completed</span>
            </div>
          </div>
          <div className="flex flex-col  md:flex-wrap md:flex-row justify-between items-start md:items-center mb-6 gap-4">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                {role === "manager" ? "Guest Overview" : "Guest Management"}
              </h1>
              <p className="text-sm text-gray-600 mt-1">
                {role === "manager"
                  ? "View all guest check-ins and check-outs"
                  : "Manage all guest check-ins and check-outs"}
              </p>
            </div>
            <div className="flex items-center gap-3 flex-wrap">
              {checkedGuests.length > 0 && (
                <>
                  <button
                    onClick={handleSubmitCheckedGuests}
                    className="flex flex-wrap items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors shadow-sm"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <div className="flex items-center gap-2">
                        <svg
                          className="animate-spin h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Processing...
                      </div>
                    ) : (
                      <>
                        <MdCheck className="text-lg" />
                        <span>Process Selected</span>
                        <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-white/20 text-xs font-medium">
                          {checkedGuests.length}
                        </span>
                      </>
                    )}
                  </button>
                  {/* <button
                 onClick={clearAllCheckedGuests}
                 className="flex items-center gap-2 px-4 py-2 bg-white text-indigo-600 border border-indigo-200 rounded-lg hover:bg-indigo-50 transition-colors shadow-sm"
                 title="Clear all selections"
               >
                 <MdClear className="text-lg" />
                 Clear
               </button> */}
                </>
              )}
              {guests.length > 0 && role !== "view only" && (
                <div className="flex items-center gap-2 px-4 py-2.5 bg-white border border-indigo-200 rounded-lg hover:bg-indigo-50 transition-colors shadow-sm">
                  <input
                    type="checkbox"
                    id="check-all"
                    checked={isAllChecked()}
                    onChange={handleCheckAll}
                    className="h-4 w-4 rounded"
                  />
                  <label
                    htmlFor="check-all"
                    className="text-sm font-medium text-indigo-600 cursor-pointer"
                  >
                    Check All
                  </label>
                </div>
              )}
              <button
                onClick={() => {
                  setShowFilters(!showFilters);
                  resetFilters();
                }}
                className="flex items-center gap-2 px-4 py-2 bg-white text-indigo-600 border border-indigo-200 rounded-lg hover:bg-indigo-50 transition-colors shadow-sm"
              >
                {showFilters ? (
                  <MdClear className="text-lg" />
                ) : (
                  <MdFilterAlt className="text-lg" />
                )}
                {showFilters ? "Hide Filters" : "Filters"}
              </button>

              {role !== "view only" && (
                <button
                  onClick={handleFormShow}
                  className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors shadow-sm"
                >
                  <MdAdd className="text-lg" />
                  Add Guest
                </button>
              )}
            </div>
          </div>
        </div>

        {showFilters && (
          <motion.div
            initial={{ opacity: 0, height: "auto" }}
            animate={{ opacity: 1, height: "auto" }}
            transition={{ duration: 0.3 }}
            className="bg-white p-6 rounded-lg shadow-sm border border-indigo-300 mx-4 mb-6"
          >
            <div className="flex justify-end mb-4">
              {Object.values(filters).some(
                (val) => val !== "" && val !== null
              ) && (
                  <button
                    onClick={resetFilters}
                    className="flex items-center gap-1 text-sm text-indigo-600 hover:text-indigo-800"
                  >
                    <MdClear className="text-lg" />
                    Clear all
                  </button>
                )}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
              <div className="space-y-1">
                <label className="block text-sm font-medium text-indigo-500">
                  Guest Name
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <MdPerson className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="name"
                    value={filters.name}
                    onChange={handleFilterChange}
                    placeholder="Search by name"
                    className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500  text-sm"
                  />
                </div>
              </div>

              <div className="space-y-1">
                <label className="block text-sm font-medium text-indigo-500">
                  Email
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <MdEmail className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="email"
                    value={filters.email}
                    onChange={handleFilterChange}
                    placeholder="Search by email"
                    className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 text-sm"
                  />
                </div>
              </div>

              <div className="space-y-1">
                <label className="block text-sm font-medium text-indigo-500">
                  Phone
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <MdPhone className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    name="phone"
                    value={filters.phone}
                    onChange={handleFilterChange}
                    placeholder="Search by phone"
                    className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:border-indigo-500 text-sm"
                  />
                </div>
              </div>

              <div className="space-y-1 relative">
                <label className="block text-sm font-medium text-indigo-500">
                  From Date
                </label>
                <div className="relative w-full">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-20">
                    <MdCalendarToday className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    readOnly
                    placeholder="DD/MM/YYYY"
                    value={
                      filters.fromDate
                        ? format(new Date(filters.fromDate), "dd/MM/yyyy")
                        : ""
                    }
                    onClick={() =>
                      document.getElementById("from-date-picker").showPicker()
                    }
                    className="absolute top-0 left-0 w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-black cursor-pointer focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm z-10"
                  />
                  <input
                    type="date"
                    id="from-date-picker"
                    name="fromDate"
                    max={date}
                    value={filters.fromDate}
                    onChange={handleFilterChange}
                    className="w-full pl-10 pr-3 py-1.5 border border-gray-300 rounded-md shadow-sm bg-transparent text-transparent caret-transparent z-0 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  />
                </div>
              </div>

              <div className="space-y-1">
                <label className="block text-sm font-medium text-indigo-500">
                  To Date
                </label>
                <div className="relative w-full">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-20">
                    <MdCalendarToday className="text-gray-400" />
                  </div>
                  <input
                    type="text"
                    readOnly
                    value={
                      filters.toDate
                        ? format(new Date(filters.toDate), "dd/MM/yyyy")
                        : ""
                    }
                    placeholder="DD/MM/YYYY"
                    onClick={() => {
                      filters.fromDate &&
                        document.getElementById("to-date-picker")?.showPicker();
                    }}
                    className={`absolute top-0 left-0 w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-black cursor-pointer focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm z-10 ${!filters.fromDate
                      ? "bg-gray-50 text-gray-500 cursor-not-allowed"
                      : ""
                      }`}
                  />
                  <input
                    type="date"
                    id="to-date-picker"
                    name="toDate"
                    value={filters.toDate}
                    onChange={handleFilterChange}
                    max={date}
                    disabled={!filters.fromDate}
                    className="w-full pl-10 pr-3 py-1.5 border border-gray-300 rounded-md shadow-sm bg-transparent text-transparent caret-transparent z-0 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  />
                </div>
              </div>
            </div>
          </motion.div>
        )}

        <div className="p-4 md:p-6 mx-auto bg-white shadow-sm overflow-hidden">
          {isRefeshing && guests.length === 0 ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
            </div>
          ) : guests.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-16 w-16 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
              <p className="mt-4 text-lg font-medium text-gray-500">
                No guests found
              </p>
            </div>
          ) : (
            <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-md">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gradient-to-r from-indigo-50 to-blue-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                      Room No
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                      Total Amount
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                      Guest Details
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                      Check-In
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                      Check-Out
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                      Notes
                    </th>
                    {role === "manager" && (
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        Added By
                      </th>
                    )}
                    <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {guests.map((guest, index) => (
                    <motion.tr
                      key={guest._id}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      className={`transition-colors duration-150 ${getGuestBgColor(
                        guest,
                        index
                      )}`}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center gap-3">
                          {guest.isCompleteCheckInDetails &&
                            !guest.generatedId &&
                            guest.checkOutDate &&
                            guest.checkOutTime &&
                            role !== "view only" &&
                            !guest.noPathikEntry && (
                              <input
                                type="checkbox"
                                checked={
                                  guest.processStatus === "pending"
                                    ? true
                                    : checkedGuests.includes(guest._id)
                                }
                                disabled={guest.processStatus === "pending"}
                                onChange={() => handleCheckboxChange(guest)}
                                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                              />
                            )}
                          <div
                            className={`inline-flex items-center text-sm font-semibold px-2.5 py-0.5 rounded-full ${guest.noPathikEntry
                              ? "bg-rose-300 text-rose-800"
                              : guest.isCompleteCheckInDetails &&
                                !guest.generatedId
                                ? "bg-green-300 text-green-800"
                                : guest.generatedId
                                  ? "bg-purple-300 text-purple-800"
                                  : "bg-yellow-300 text-yellow-800"
                              }`}
                          >
                            {guest?.roomNumber?.roomNo}(
                            {guest.sameDayCheckInCount})
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex flex-col space-y-1">
                          {!guest.checkOutDate &&
                            !guest.checkOutTime &&
                            !guest.isCancelled && (
                              <>
                                <div className="text-sm font-medium text-gray-900">
                                  Payable: ₹{guest.payableAmount || 0}
                                </div>
                                {renderPaymentDetails(guest)}
                              </>
                            )}
                          {guest.checkOutDate && !guest.isCancelled && (
                            <>
                              <div className="text-sm font-medium text-gray-900">
                                Total Paid: ₹{guest.totalPaidAmount}
                              </div>
                              <>
                                <div className="text-xs text-blue-600">
                                  Advance Paid: ₹{guest.advancePayAmount || 0}
                                </div>
                                {guest.returnAmount > 0 ? (
                                  <div className="text-xs font-medium text-red-600">
                                    Return: ₹{guest.returnAmount}
                                  </div>
                                ) : (
                                  <div className="text-xs font-medium text-green-600">
                                    Paid: ₹{guest.paidAmount}
                                  </div>
                                )}
                              </>
                              {guest.totalPaidAmount <
                                (guest.payableAmount || 0) &&
                                role === "manager" && (
                                  <div className="group relative">
                                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                                      <MdWarning className="mr-1 h-3 w-3" />
                                      Amount Issue
                                    </span>

                                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-500 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10">
                                      Expected: ₹{guest.payableAmount}
                                      <br />
                                      Actual: ₹{guest.totalPaidAmount}
                                    </div>
                                  </div>
                                )}
                            </>
                          )}
                          {guest.isCancelled && (
                            <>
                              <div className="text-sm font-medium text-gray-900">
                                Paid: ₹{guest.advancePayAmount || 0}
                              </div>
                              <div className="text-xs font-medium text-purple-500">
                                Return: ₹{guest.advancePayAmount || 0}
                              </div>
                            </>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">
                          {/* Main Guest */}
                          <div className="font-semibold">
                            {guest.guestId.firstName} {guest.guestId.middleName}{" "}
                            {guest.guestId.lastName}
                          </div>

                          {/* Other Guests */}
                          {guest.otherGuests &&
                            guest.otherGuests.length > 0 && (
                              <div className="mt-1">
                                {guest.otherGuests.map((otherGuest, index) => (
                                  <div
                                    key={otherGuest._id || index}
                                    className="text-xs text-gray-600"
                                  >
                                    Guest {index + 1}: {otherGuest.fullName}
                                  </div>
                                ))}
                              </div>
                            )}

                          {/* Contact Info */}
                          <div className="text-xs text-gray-500 mt-1">
                            Contact: {guest.guestId.mobileNumber}
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {formatTimeToAMPM(guest.checkInTime)}
                        </div>
                        <div className="text-xs text-gray-500">
                          {new Date(guest.checkInDate?.split("T")[0])
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-")}
                        </div>
                        {guest.createdAt && role !== "receptionist" && (
                          <div>
                            <div
                              className={`text-xs ${isCheckoutDelayed(
                                guest.checkInDate,
                                guest.checkInTime,
                                guest.createdAt
                              )
                                ? "text-red-500"
                                : "text-gray-500"
                                }`}
                            >
                              (
                              {new Date(guest.createdAt)
                                .toLocaleDateString("en-GB", {})
                                .replace(/\//g, "-")}
                              <br />
                              {new Date(guest.createdAt).toLocaleTimeString(
                                "en-US",
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                              )
                            </div>
                          </div>
                        )}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        {guest.isCancelled ? (
                          <div className="flex flex-col space-y-2">
                            <div className="flex items-center">
                              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                <svg
                                  className="mr-1 h-2 w-2 text-red-400"
                                  fill="currentColor"
                                  viewBox="0 0 8 8"
                                >
                                  <circle cx="4" cy="4" r="3" />
                                </svg>
                                Cancelled
                              </span>
                            </div>
                            <div className="text-xs text-gray-500 pl-1">
                              (
                              {new Date(guest.cancelCheckinDateTime)
                                .toLocaleDateString("en-GB", {})
                                .replace(/\//g, "-")}
                              <br />
                              {new Date(
                                guest.cancelCheckinDateTime
                              ).toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                              )
                            </div>
                          </div>
                        ) : guest.checkOutDate && guest.checkOutTime ? (
                          <div className="space-y-1">
                            <div>
                              <div className="text-sm text-gray-900">
                                {formatTimeToAMPM(guest.checkOutTime)}
                              </div>
                              <div className="text-xs text-gray-500">
                                {new Date(guest.checkOutDate.split("T")[0])
                                  .toLocaleDateString("en-GB")
                                  .replace(/\//g, "-")}
                              </div>
                            </div>
                            {guest.confirmcheckOutDate &&
                              role !== "receptionist" && (
                                <div>
                                  <div
                                    className={`text-xs ${isCheckoutDelayed(
                                      guest.checkOutDate,
                                      guest.checkOutTime,
                                      guest.confirmcheckOutDate
                                    )
                                      ? "text-red-500"
                                      : "text-gray-500"
                                      }`}
                                  >
                                    (
                                    {new Date(guest.confirmcheckOutDate)
                                      .toLocaleDateString("en-GB", {})
                                      .replace(/\//g, "-")}
                                    <br />
                                    {new Date(
                                      guest.confirmcheckOutDate
                                    ).toLocaleTimeString("en-US", {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}
                                    )
                                  </div>
                                </div>
                              )}
                          </div>
                        ) : (
                          <>
                            {role !== "view only" ? (
                              <button
                                className="inline-flex justify-center border border-transparent py-1.5 px-2 font-medium focus:outline-none bg-orange-500 text-white text-sm rounded-md hover:bg-orange-600 transition-colors"
                                onClick={() => handleCheckoutClick(guest)}
                              >
                                Checkout
                              </button>
                            ) : (
                              <span className="inline-flex justify-center items-center py-1 px-2 font-medium text-white text-sm rounded-full bg-orange-500 shadow-sm">
                                Checkout Pending
                              </span>
                            )}
                          </>
                        )}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {guest.notes}
                        </div>
                      </td>
                      {role === "manager" && (
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {guest.addedBy?.name}
                          </div>
                        </td>
                      )}
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex items-center space-x-2">
                          {!guest.isCancelled && (
                            <>
                              <button
                                onClick={() => handleEdit(guest)}
                                className="text-indigo-600 hover:text-indigo-900 p-1"
                                title="Edit"
                              >
                                <MdEdit className="h-6 w-6" />
                              </button>
                              {guest.checkOutDate &&
                                guest.checkOutTime &&
                                guest.isCompleteCheckInDetails &&
                                role !== "view only" && (
                                  <button
                                    onClick={() => handlePrint(guest)}
                                    className={`p-1 ${guest.isdownloadPdf > 0
                                      ? "text-green-600 hover:text-green-800"
                                      : "text-blue-600 hover:text-blue-800"
                                      }`}
                                    title="Print"
                                  >
                                    <MdPrint className="h-6 w-6" />
                                  </button>
                                )}
                            </>
                          )}
                          {!guest.checkOutDate &&
                            !guest.checkOutTime &&
                            !guest.isCancelled &&
                            role !== "view only" &&
                            (() => {
                              const checkInDateTime = new Date(guest.createdAt);
                              const now = new Date();
                              const diffInMs = now - checkInDateTime;
                              return diffInMs < 15 * 60 * 1000 ? (
                                <button
                                  onClick={() => handleCancelCheckin(guest)}
                                  className="text-red-600 hover:text-red-800 p-1"
                                  title="Cancel Check-in"
                                >
                                  <MdCancel className="h-6 w-6" />
                                </button>
                              ) : null;
                            })()}

                          {role === "manager" && (
                            <button
                              onClick={() => handleDeleteGuest(guest)}
                              className="text-red-700 hover:text-red-900 p-1"
                              title="Delete Guest"
                            >
                              <MdDelete className="h-6 w-6" />
                            </button>
                          )}
                        </div>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Combined Summary and Pagination Section */}
          {guests.length > 0 && (
            <div className="mt-6 flex flex-col sm:flex-row justify-between items-center gap-4 p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
              {/* Summary on the left */}
              <div className="flex items-center gap-6">
                <div className="flex items-center gap-2">
                  <div className="p-2 bg-indigo-100 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Total Guests</p>
                    <p className="text-sm font-semibold text-indigo-600">
                      {summaryData.totalGuests}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <div className="p-2 bg-green-100 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-green-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Total Revenue</p>
                    <p className="text-sm font-semibold text-green-600">
                      ₹{summaryData.totalPaidAmountAllGuests.toLocaleString()}
                    </p>
                  </div>
                </div>
              </div>
              {/* Pagination */}
              <div className="flex justify-center select-none w-full sm:w-auto overflow-x-auto">
                <ReactPaginate
                  previousLabel={
                    <span className="flex items-center gap-1 text-indigo-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Previous</span>
                    </span>
                  }
                  nextLabel={
                    <span className="flex items-center gap-1 text-indigo-600">
                      <span>Next</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  }
                  breakLabel={<span className="px-2">...</span>}
                  pageCount={totalPages}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"flex items-center gap-1 text-sm"}
                  pageClassName={"flex"}
                  pageLinkClassName={
                    "px-3 py-1.5 rounded-md border border-gray-200 hover:bg-gray-100 transition-colors duration-200 select-none"
                  }
                  activeLinkClassName={
                    "text-indigo-600 border-indigo-400 hover:bg-gradient-to-r hover:from-indigo-50 hover:to-blue-50 transition-colors duration-200"
                  }
                  previousClassName={"flex select-none"}
                  previousLinkClassName={
                    "px-3 py-1.5 rounded-md border border-indigo-400 hover:bg-gradient-to-r hover:from-indigo-50 hover:to-blue-50 transition-colors duration-200 flex items-center gap-1 select-none disabled:border-gray-300"
                  }
                  nextClassName={"flex select-none"}
                  nextLinkClassName={
                    "px-3 py-1.5 rounded-md border border-indigo-400 hover:bg-gradient-to-r hover:from-indigo-50 hover:to-blue-50 transition-colors duration-200 flex items-center gap-1 select-none disabled:border-gray-300"
                  }
                  breakClassName={"flex"}
                  breakLinkClassName={"px-2 py-1.5 select-none"}
                  disabledClassName={"opacity-50 cursor-not-allowed "}
                  disabledLinkClassName={"hover:bg-transparent text-gray-500"}
                  forcePage={currentPage - 1}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {formToShow === "formB" && (
        <CheckoutModal checkOutData={checkOutData} action={fetchGuests} />
      )}

      {formToShow === "formA" && (
        <GuestAndCheckInForm
          action={fetchGuests}
          editvalue={editvalue}
          isEdit={isEdit}
          setEditvalue={setEditvalue}
          setisEdit={setisEdit}
          role={role}
        />
      )}
      {isdownloadPdf && (
        <PDFContent
          formData={pdfdata}
          isdownloadPdf={isdownloadPdf}
          setPdfdata={setPdfdata}
          setisdownloadPdf={setisdownloadPdf}
          onPdfDownloaded={() => fetchGuests(currentPage)}
        />
      )}

      {/* {loading && <ExtensionWatcher />}
      {showInactiveModal && <ExtensionModel />} */}

      {showCancelConfirmation && (
        <DeleteConfirmationModal
          isOpen={showCancelConfirmation}
          onClose={handleCancelConfirmationClose}
          onConfirm={handleConfirmCancel}
          type="cancel"
          guestData={guestToCancel}
        />
      )}

      {showDeleteConfirmation && (
        <DeleteConfirmationModal
          isOpen={showDeleteConfirmation}
          onClose={handleDeleteConfirmationClose}
          onConfirm={handleConfirmDelete}
          type="delete"
          guestData={guestToDelete}
        />
      )}
    </div>
  );
};

export default GuestData;
